// extracted by mini-css-extract-plugin
export default {"container":"iN-z","topReviewHeading":"jN-z","criticalReview":"kN-z","favorableReview":"lN-z","vsSeparator":"mN-z"};